<template>
  <div class="dynamic-faq-item rounded overflow-hidden">
    <OImage v-bind="image" img-class="rounded-t w-full object-cover" />
    <div class="py-6 px-3">
      <h5 class="ota-h4 font-semibold mb-4" v-text="title" />
      <ul>
        <li
          v-for="question in questions"
          :key="question.title"
          class="mb-3"
        >
          <NuxtLink
            :to="{ path: `${$i18n.localePath(question.to)}?${question.queryParams}` }"
          >
            <span v-html="question.title" />
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import OImage from '@/components/OImage'

export default {
  name: 'DynamicFAQItem',
  components: {
    OImage
  },
  props: {
    image: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    questions: {
      type: Array,
      default: () => ([]),
      validator: value => value.every(obj => ['title', 'to', 'queryParams'].every(prop => obj.hasOwnProperty(prop)))
    }
  }
}
</script>

<style lang="postcss" scoped>
.dynamic-faq-item{
  background-color: #F7F7F7;

  >>> .object-cover {
    @apply object-cover !important;
  }

  a span {
    color: var(--color-neutral-800, #262626);
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    text-decoration-line: underline;
  }
}
</style>
